var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.75H6C4.78125 3.75 3.98438 4.40625 3.75 5.625L2.25 12.75V18C2.25173 18.5962 2.48934 19.1675 2.91092 19.5891C3.3325 20.0107 3.9038 20.2483 4.5 20.25H19.5C20.0962 20.2483 20.6675 20.0107 21.0891 19.5891C21.5107 19.1675 21.7483 18.5962 21.75 18V12.75L20.25 5.625C20.0156 4.35938 19.1719 3.75 18 3.75Z",
    stroke: "#E46869",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75H18M2.25 12.75H9H2.25ZM15 12.75H21.75H15ZM9 12.75C9 13.5456 9.31607 14.3087 9.87868 14.8713C10.4413 15.4339 11.2044 15.75 12 15.75C12.7956 15.75 13.5587 15.4339 14.1213 14.8713C14.6839 14.3087 15 13.5456 15 12.75H9ZM6.75 6.75H17.25H6.75Z",
    stroke: "#E46869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTray);
export default __webpack_public_path__ + "static/media/tray.3a1988b9f271f7f90dc7d9ecd0d4af49.svg";
export { ForwardRef as ReactComponent };